import React from "react";
import ReactDOM from "react-dom";

import App from "./MentorQueue/Components/App";
import { ThemeProvider } from "@material-ui/core/styles";
import theme from "./MentorQueue/theme";
import CssBaseline from "@material-ui/core/CssBaseline";
// import * as serviceWorker from './serviceWorker';
import configureStore from "./MentorQueue/redux/configureStore";
import { Provider as ReduxProvider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";

import { Settings } from "./Shared/GeneratedTypes";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
let guideStreamSettings = (window as any).GuideStream.settings as Settings;
//https://docs.microsoft.com/en-us/azure/azure-monitor/app/javascript#npm-based-setup
const appInsights = new ApplicationInsights({
    config: {
        instrumentationKey: guideStreamSettings.instrumentationKey,
        autoTrackPageVisitTime: true,
    },
});
appInsights.loadAppInsights();
appInsights.trackPageView();

//@ts-ignore
const store = configureStore();

ReactDOM.render(
    <ReduxProvider store={store}>
        <Router>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <App />
            </ThemeProvider>
        </Router>
    </ReduxProvider>,
    document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
